<template>
  <IconLucideCircleCheck />
</template>
